import {
  SET_USER_DATA,
  REMOVE_USER_DATA,
  USER_LOGGED_OUT,
  PAYMENT_ERROR,
  USER_SESSION_OUT,
  RESET_SESSION_TIMER
} from "../actions/UserActions";

const initialState = {};

const userReducer = function(state = initialState, action) {
  switch (action.type) {
    case SET_USER_DATA: {
      return {
        ...initialState,
        ...action.data
      };
    }
    case REMOVE_USER_DATA: {
      return {
        ...initialState
      };
    }
    case PAYMENT_ERROR: {
      if (action.status === 401) { // this should mimic a logout
        return initialState;
      } else {
        return state;
      }
    }
    case USER_LOGGED_OUT: {
      return initialState;
    }
    case USER_SESSION_OUT: {
      return{
        ...initialState,...action.data
      }
    }
    case RESET_SESSION_TIMER: {
      return{
        ...initialState,...action.data
      }
    }
    default: {
      return state;
    }
  }
};

export default userReducer;
